import { useMemo } from "react";
import { SelectionFeature } from "src/js/stores/map/store";
import { useLayerScope } from "./useLayerScope";
import { addBufferToGeometry } from "react-migration/domains/sites/helpers/addBufferToGeometry";
import { ScopeType } from "src/js/stores/site/store";

export function useGeometryTransformer(siteId: string, layerId: string, selection: SelectionFeature) {
  const [scopeConfig] = useLayerScope(siteId, layerId);

  const transformedGeometry = useMemo(() => {
    const baseGeometry = selection.feature?.geometry ?? null;
    if (!baseGeometry) return null;

    if (scopeConfig.scopeType === ScopeType.NEARBY) {
      const radius = scopeConfig.radius ?? 100;
      return addBufferToGeometry(baseGeometry, radius)?.geometry ?? null;
    }

    // For ON_SITE, return the original geometry - let individual hooks handle negative buffer
    return baseGeometry;
  }, [selection.feature?.geometry, scopeConfig.scopeType, scopeConfig.radius]);

  return {
    transformedGeometry,
    scopeConfig,
  };
}
